import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { BasicListenable3uz4a8xs34a0h as BasicListenable } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  SocketOverload2oan4qiwxidew as SocketOverload,
  SocketChanges3116hd430s44s as SocketChanges,
  QueryResult2ufeva9wjs3uo as QueryResult,
  MutationResultxmj9lk13qzu5 as MutationResult,
  MultiGetResults6dlyquirmyb as MultiGetResult,
  DeletionResultccwd2e565l92 as DeletionResult,
} from './CacheUpdate.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { WithTimestampAndLimitv5k4d7fr8du4 as WithTimestampAndLimit } from './WithTimestamp.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  toSet2orjxp16sotqu as toSet,
  plus310ted5e4i90h as plus,
  sortedWith2csnbbb21k0lg as sortedWith,
  take3onnpy6q7ctcz as take,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { ensureTotaldlyk8c4gc8xl as ensureTotal } from './utils.mjs';
import { get_comparator3ku3zoggvro4l as get_comparator } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortPart.mjs';
import { ListReconstructionCalculator2dt2xl53wlcst as ListReconstructionCalculator } from './ListReconstructionCalculator.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NaiveListReconstructionCalculatorClass;
function NaiveListReconstructionCalculator() {
  if (NaiveListReconstructionCalculatorClass === VOID) {
    class $ {
      constructor(serializer, log) {
        log = log === VOID ? null : log;
        this.heo_1 = serializer;
        this.ieo_1 = log;
        this.jeo_1 = HashMap().n8();
        this.keo_1 = BasicListenable().naq();
      }
      tek(query) {
        return this.keo_1;
      }
      uek(update) {
        var tmp0_safe_receiver = this.ieo_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.fcv(['Handling update ' + toString(update)]);
        }
        if (update instanceof DeletionResult()) {
          // Inline function 'kotlin.collections.iterator' call
          var iter = this.jeo_1.d2().m1();
          while (iter.n1()) {
            var entry = iter.o1();
            var old = entry.f2();
            var new_0 = this.peo(old.cen_1, entry.e2(), emptyList(), update.yej_1);
            entry.yb(old.oeo(new_0));
          }
        } else {
          if (update instanceof MultiGetResult()) {
            // Inline function 'kotlin.collections.iterator' call
            var iter_0 = this.jeo_1.d2().m1();
            while (iter_0.n1()) {
              var entry_0 = iter_0.o1();
              var old_0 = entry_0.f2();
              var new_1 = this.peo(old_0.cen_1, entry_0.e2(), update.oej(), update.vej_1);
              entry_0.yb(old_0.oeo(new_1));
            }
          } else {
            if (update instanceof MutationResult()) {
              // Inline function 'kotlin.collections.iterator' call
              var iter_1 = this.jeo_1.d2().m1();
              while (iter_1.n1()) {
                var entry_1 = iter_1.o1();
                var old_1 = entry_1.f2();
                var new_2 = this.neo(old_1.cen_1, entry_1.e2(), update.xej_1);
                entry_1.yb(old_1.oeo(new_2));
              }
            } else {
              if (update instanceof QueryResult()) {
                var tmp0 = this.jeo_1;
                var tmp2 = update.tej_1;
                // Inline function 'kotlin.collections.set' call
                var value = new (WithTimestampAndLimit())(update.uej_1, update.tej_1.v49_1);
                tmp0.s3(tmp2, value);
              } else {
                if (update instanceof SocketChanges()) {
                  // Inline function 'kotlin.collections.iterator' call
                  var iter_2 = this.jeo_1.d2().m1();
                  while (iter_2.n1()) {
                    var entry_2 = iter_2.o1();
                    var old_2 = entry_2.f2();
                    var tmp0_0 = update.sej_1;
                    var tmp$ret$5;
                    $l$block_0: {
                      // Inline function 'kotlin.collections.any' call
                      var tmp;
                      if (isInterface(tmp0_0, Collection())) {
                        tmp = tmp0_0.i1();
                      } else {
                        tmp = false;
                      }
                      if (tmp) {
                        tmp$ret$5 = false;
                        break $l$block_0;
                      }
                      var _iterator__ex2g4s = tmp0_0.m1();
                      while (_iterator__ex2g4s.n1()) {
                        var element = _iterator__ex2g4s.o1();
                        var tmp_0;
                        if (element.meo().equals(entry_2.e2().s49_1)) {
                          var tmp0_safe_receiver_0 = element.leo();
                          var tmp_1;
                          if (tmp0_safe_receiver_0 == null) {
                            tmp_1 = null;
                          } else {
                            // Inline function 'kotlin.let' call
                            tmp_1 = old_2.een_1.y26(tmp0_safe_receiver_0) > 0;
                          }
                          tmp_0 = tmp_1 === true;
                        } else {
                          tmp_0 = false;
                        }
                        if (tmp_0) {
                          tmp$ret$5 = true;
                          break $l$block_0;
                        }
                      }
                      tmp$ret$5 = false;
                    }
                    var completeUpdate = tmp$ret$5;
                    if (completeUpdate) {
                      var new_3 = this.peo(old_2.cen_1, entry_2.e2(), update.pej_1, update.qej_1);
                      // Inline function 'com.lightningkite.now' call
                      var tmp$ret$9 = get_default(Companion_instance).d1m();
                      entry_2.yb(old_2.oeo(new_3, VOID, tmp$ret$9));
                    } else {
                      var new_4 = this.neo(old_2.cen_1, entry_2.e2(), update.pej_1);
                      entry_2.yb(old_2.oeo(new_4));
                    }
                  }
                } else {
                  if (update instanceof SocketOverload()) {
                    this.jeo_1.v3();
                  } else {
                    noWhenBranchMatchedException();
                  }
                }
              }
            }
          }
        }
        this.keo_1.oaq();
      }
      vek(query) {
        return this.jeo_1.p3(query);
      }
      wek(query) {
        return query;
      }
      peo(_this__u8e3s4, query, edits, removed) {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().u(collectionSizeOrDefault(edits, 10));
        var _iterator__ex2g4s = edits.m1();
        while (_iterator__ex2g4s.n1()) {
          var item = _iterator__ex2g4s.o1();
          var tmp$ret$0 = item.h40();
          destination.v(tmp$ret$0);
        }
        var rem = plus(removed, toSet(destination));
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination_0 = ArrayList().w();
        var _iterator__ex2g4s_0 = _this__u8e3s4.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element = _iterator__ex2g4s_0.o1();
          if (!rem.t1(element.h40())) {
            destination_0.v(element);
          }
        }
        var filteredList = destination_0;
        var combinedList = plus(filteredList, edits);
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination_1 = ArrayList().w();
        var _iterator__ex2g4s_1 = combinedList.m1();
        while (_iterator__ex2g4s_1.n1()) {
          var element_0 = _iterator__ex2g4s_1.o1();
          if (query.s49_1.t3q(element_0)) {
            destination_1.v(element_0);
          }
        }
        // Inline function 'kotlin.collections.distinctBy' call
        var set = HashSet().ha();
        var list = ArrayList().w();
        var _iterator__ex2g4s_2 = destination_1.m1();
        while (_iterator__ex2g4s_2.n1()) {
          var e = _iterator__ex2g4s_2.o1();
          var key = e.h40();
          if (set.v(key)) {
            list.v(e);
          }
        }
        // Inline function 'kotlin.let' call
        var it = sortedWith(list, ensureNotNull(get_comparator(ensureTotal(query.t49_1, this.heo_1))));
        return query.v49_1 > 0 ? take(it, query.v49_1) : it;
      }
      neo(_this__u8e3s4, query, edits, removed, $super) {
        removed = removed === VOID ? emptyList() : removed;
        return $super === VOID ? this.peo(_this__u8e3s4, query, edits, removed) : $super.peo.call(this, _this__u8e3s4, query, edits, removed);
      }
    }
    initMetadataForClass($, 'NaiveListReconstructionCalculator', VOID, VOID, [ListReconstructionCalculator()]);
    NaiveListReconstructionCalculatorClass = $;
  }
  return NaiveListReconstructionCalculatorClass;
}
//region block: exports
export {
  NaiveListReconstructionCalculator as NaiveListReconstructionCalculator3qc7njeca2h45,
};
//endregion

//# sourceMappingURL=NaiveListReconstructionCalculator.mjs.map
